import script from "./WalletInput.vue?vue&type=script&lang=ts&setup=true"
export * from "./WalletInput.vue?vue&type=script&lang=ts&setup=true"

import "./WalletInput.vue?vue&type=style&index=0&id=09bcfd56&lang=scss"

const __exports__ = script;

export default __exports__